<script setup>
import { useRouter } from 'vue-router'
import Card from 'primevue/card'
import Divider from 'primevue/divider'
import Button from 'primevue/button'
import { ref } from 'vue'
import FacilityForm from '@/components/facility/FacilityForm.vue'


const props = defineProps({
  inProgressObjects: { type: Number, default: 0 },
  archiveObjects: { type: Number, default: 0 },
  worksInProgress: { type: Number, default: 0 },
  worksCompleted: { type: Number, default: 0 },
  customerId: { type: [Number, String], required: false, default: undefined },
})

const router = useRouter();

const showFacilityForm = ref(false)

function openCreateFacility() {
  if (props.customerId == null) return
  showFacilityForm.value = true
}

function onFacilitySaved(created) {
  showFacilityForm.value = false
  // Если бэк вернул id — переходим на детали объекта, иначе на список
  if (created?.id) {
    router.push(`/facilities/${created.id}`)
  } else {
    router.push('/facilities')
  }
}

// Запишем пресет и перейдём на страницу (URL без query)
function goFacilities(status) {
  if (props.customerId == null) return;
  sessionStorage.setItem(
      'facilities:list:preset',
      JSON.stringify({ customer_id: String(props.customerId), status })
  );
  router.push('/facilities');
}

function goWorks(status) {
  if (props.customerId == null) return;
  sessionStorage.setItem(
      'works:list:preset',
      JSON.stringify({ customer: String(props.customerId), status })
  );
  router.push('/works');
}
</script>

<template>
  <Card class="max-w-xl min-w-[15.625rem] w-full p-0 text-sm">
    <template #content>
      <!-- Объекты -->
      <div class="mx-2">
        <div class="flex items-center justify-between font-semibold mb-1">
          <span>Объекты</span>
          <Button
              icon="pi pi-plus"
              severity="secondary"
              size="small"
              rounded
              text
              :disabled="customerId == null"
              @click="openCreateFacility"
          />
        </div>
        <div class="flex justify-between gap-16">
          <div>
            <i class="pi pi-cog pi-spin text-gray-500 mr-2" title="В работе"></i>
            <b
                :class="{'cursor-pointer underline-offset-2 hover:underline': customerId != null}"
                @click="goFacilities('ACTIVE')"
            >{{ inProgressObjects }}</b>
          </div>
          <div>
            <i class="pi pi-list-check text-gray-500 mr-2" title="Архив"></i>
            <b
                :class="{'cursor-pointer underline-offset-2 hover:underline': customerId != null}"
                @click="goFacilities('ARCHIVED')"
            >{{ archiveObjects }}</b>
          </div>
        </div>
      </div>

      <Divider class="my-1" />

      <!-- Работы -->
      <div class="mx-2">
        <div class="font-semibold mb-1">Работы</div>
        <div class="flex gap-8 justify-between">
          <div>
            <i class="pi pi-cog pi-spin text-gray-500 mr-2" title="Выполняются"></i>
            <b
                :class="{'cursor-pointer underline-offset-2 hover:underline': customerId != null}"
                @click="goWorks('ACTIVE')"
            >{{ worksInProgress }}</b>
          </div>
          <div>
            <i class="pi pi-list-check text-gray-500 mr-2" title="Завершены"></i>
            <b
                :class="{'cursor-pointer underline-offset-2 hover:underline': customerId != null}"
                @click="goWorks('ARCHIVED')"
            >{{ worksCompleted }}</b>
          </div>
        </div>
      </div>
    </template>
  </Card>
  <FacilityForm
      v-model:visible="showFacilityForm"
      :preset-customer-id="customerId"
      @save="onFacilitySaved"
  />

</template>

<style scoped>
:deep(.p-card-body) {
  padding: 0.5rem;
}
</style>